import { Box, Divider, IconButton, Paper, Typography } from '@mui/material';
import CancelIcon from '@mui/icons-material/Cancel';
import { PaymentForm } from '../../interfaces/Checkout/PaymentForm';
import { ShippingMethod } from '../../interfaces/Shipping/ShippingMethod';
import { formatCurrency } from '../../utils/Currency';

type RowProps = {
  label: string;
  value: number;
  onClear?: () => void;
};

const Row = ({ label, value, onClear }: RowProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <Typography sx={{ fontWeight: 700 }}>{label}</Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <Typography>{formatCurrency(value)}</Typography>
        {!!onClear && (
          <IconButton size='small' color='error' onClick={onClear}>
            <CancelIcon />
          </IconButton>
        )}
      </Box>
    </Box>
  );
};

type BreakdownCardProps = {
  form: PaymentForm;
  shippingMethods: ShippingMethod[];
  subtotal: number;
  grandTotal: number;
  isFreeShipping: boolean;
  onRemovePoint: () => void;
  onRemoveCoupon: () => void;
};

export const BreakdownCard = ({
  form,
  subtotal,
  grandTotal,
  shippingMethods,
  isFreeShipping,
  onRemovePoint,
  onRemoveCoupon,
}: BreakdownCardProps) => {
  const shippingMethod = shippingMethods.find(
    (x) => x.id === form.shippingMethod,
  );

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        gap: 1.5,
        alignItems: 'stretch',
      }}
    >
      <Paper
        elevation={3}
        sx={{
          px: 2.5,
          py: 1,
          boxSizing: 'border-box',
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
        }}
      >
        <Row label='Ara Toplam' value={subtotal} />
        {!!shippingMethod && (
          <Row
            label={shippingMethod.name}
            value={
              isFreeShipping
                ? shippingMethod.discountedPrice
                : shippingMethod.price
            }
          />
        )}
        {!!form.point && (
          <Row label='Puan' value={-form.point} onClear={onRemovePoint} />
        )}
        {!!form.couponAmount && (
          <Row
            label='Kupon'
            value={-form.couponAmount}
            onClear={onRemoveCoupon}
          />
        )}

        <Divider sx={{ my: 1 }} />

        <Row label='Toplam' value={grandTotal} />
      </Paper>
    </Box>
  );
};
